import { useState } from 'react';

import { SavedCard } from './components/payment-method/saved-cards';
import ShowMore from './components/show-more/show-more.component';
import PaymentMethodTitle from './components/title/payment-method-title';
import type { SavedCardsProps } from './interfaces';

export const SavedCards = ({ savedCards }: SavedCardsProps) => {
  const [showMore, setShowMore] = useState(false);

  if (savedCards.length === 0) {
    return null;
  }

  const savedCardsToShow = showMore ? savedCards : savedCards.slice(0, 2);

  return (
    <div className="co-flex co-flex-col co-gap-24px">
      <PaymentMethodTitle title={'Mis tarjetas'} />
      {savedCardsToShow?.map((savedCard, index) => {
        return (
          <SavedCard
            savedCard={savedCard}
            accordionIndex={1}
            index={index}
            key={index}
          />
        );
      })}
      {savedCards.length > 2 && (
        <ShowMore showMore={showMore} setShowMore={setShowMore} />
      )}
    </div>
  );
};
